import Notify from "devextreme/ui/notify"

// Interface para configuração de ambiente
interface EnvironmentConfig {
    BaseSpaUrl: string;
    CosmosWebApiUrl: string;
    DashboardApiUrl: string;
    FileManagerUrl: string;
    WebApiUrl: string;
    AuthUrl: string;
    PortalUrl: string;
    UploadUrl: string;
}

const isLocalDevelopmentLogin = (): boolean => {
    return window.location.hostname === 'localhost' || 
           window.location.hostname === '127.0.0.1' ||
           window.location.hostname.startsWith('192.168.') ||
           window.location.hostname.includes('local');
};

export const isDevelopmentLogin = (): boolean => {
    return isLocalDevelopmentLogin() || 
           window.location.hostname.includes('dev') ||
           window.location.hostname.includes('desenvolvimento') ||
           window.location.hostname.includes('homolog');
};

// Configuração padrão (fallback)
const DEFAULT_ENVIRONMENT: EnvironmentConfig = {
    BaseSpaUrl: isDevelopmentLogin() ? "https://nazaria-dev.homologacao.cosmospro.com.br/" : "https://nazaria.cosmospro.com.br/",
    CosmosWebApiUrl: "/rest/",
    DashboardApiUrl: "/analysis/",
    FileManagerUrl: "/storage/",
    WebApiUrl: "/odata/",
    AuthUrl: isDevelopmentLogin() ? "https://auth.homologacao.cosmospro.com.br/nazaria-dev/" : "https://auth.cosmospro.com.br/BZP/",
    PortalUrl: isDevelopmentLogin() ? "https://nazaria-dev.homologacao.cosmospro.com.br" : "https://nazaria.cosmospro.com.br",
    UploadUrl: isDevelopmentLogin() ? "https://mvc.cosmospro.homologacao.com.br/uploads/" : "https://mvc.cosmospro.com.br/uploads/"
};



// Função para obter configuração do ambiente
export const getEnvironmentConfig = (): EnvironmentConfig => {
    // Sempre retorna a configuração padrão de nazaria.cosmospro.com.br
    return DEFAULT_ENVIRONMENT;
};

// URLs baseadas na configuração de ambiente
export const uploadURL = () => {
    const config = getEnvironmentConfig();
    return config.UploadUrl;
};

export const URLCustonView = (customView: string) => {
    return "https://nazaria.cosmospro.com.br/odata/odata/CustomViews(Name='" + customView + "')/ExecuteAndReceiveData()";
};

export const URLCustomAction = (customAction: string) => {
    return "https://nazaria.cosmospro.com.br/odata/odata/ExecuteCustomAction/ExecuteAction?ActionName=" + customAction;
};

export const authTokenUrl = () => {
    const config = getEnvironmentConfig();
    return `${config.AuthUrl}connect/token`;
};

export const TPC_Lista_Status_Contas_CRM = "TPC_Lista_Status_Contas_CRM";

export const staticToken = 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjUzQTk0RkM4MTg4Qzg3NkE5Njk2Mzg1QjU4NTUxQzg4OTYxNDE0RDdSUzI1NiIsInR5cCI6ImF0K2p3dCIsIng1dCI6IlU2bFB5QmlNaDJxV2xqaGJXRlVjaUpZVUZOYyJ9.eyJuYmYiOjE3NTI2NzUzNDYsImV4cCI6MTc1MjY3ODk0NiwiaXNzIjoiaHR0cHM6Ly9hdXRoLmNvc21vc3Byby5jb20uYnIiLCJhdWQiOiJodHRwczovL2F1dGguY29zbW9zcHJvLmNvbS5ici9yZXNvdXJjZXMiLCJjbGllbnRfaWQiOiJKYXZhc2NyaXB0Q2xpZW50Iiwic3ViIjoiMTQ3NDciLCJhdXRoX3RpbWUiOjE3NTI2Njk0OTcsImlkcCI6ImxvY2FsIiwiTG9naW5TZXNzaW9uSUQiOiIwNTI4M2FhZS05OTkxLTQ3ZjgtOGZmZi0wZDgzNzA2NWVhZjAiLCJOYW1lIjoicHJvY2ZpdC5qYkBwcm9jZml0LmNvbS5iciIsIkZyaWVuZGx5TmFtZSI6Ik5hesOhcmlhIERpc3RyaWJ1aWRvcmEiLCJQcm9maWxlIjoiMSIsIkpvYlJvbGUiOiI2NCIsIkluaXRpYWxzIjoiTkQiLCJVc2VySWRlbnRpZmljYXRpb25DaGF0IjoiVElkLTEwMDI1OlVJZC0xNDc0NyIsIlVzZXJDaGF0U2lnbmF0dXJlIjoiNDc2MDg4YWU0ODQ4MDc0NDAxZmZkYmFiYTM4MGQyMDQ1YTZmMjgwYzM0YzE5NTM1ZTcwZjBiODhiOGMwYzg3NSIsIldlZWtlbmRTY2FsZSI6IjEiLCJVc2VyUGljdHVyZSI6IjM5MmFmNDRkLWJmOTMtNDU3OC1iMWVjLTdjNzMyYzc2ZDhiZi5qcGciLCJyb2xlIjoiYWRtaW4iLCJUZW5hbnRJZCI6IjEwMDI1IiwiTG9nbyI6ImY5YWE4MmI1LTM1OGYtNDhjMi1iMzYxLTZiOTc2ZTZkOTYxYy5wbmciLCJJY29uIjoiZmM3MWUxODQtNDM0OS00ZTVlLWExYjAtZTc5NWJiYjE4ZTE4LnBuZyIsIkJhY2tncm91bmRJbWFnZSI6IiIsIk1haW5Db2xvciI6IiMyYzM1NjMiLCJGb250Q29sb3IiOiIjZmZmZmZmIiwiVGVuYW50TmFtZSI6Ik5hesOhcmlhIERpc3RyaWJ1aWRvcmEiLCJUZW5hbnRLZXkiOiJCWlAiLCJCcmFuY2giOiI5IiwiRW1haWwiOiJmaWxpcGUuY29zdGFAY29zbW9zcHJvLmNvbS5iciIsIlRlbmFudERvbWFpbiI6Im5hemFyaWEiLCJBc3NvY2lhdGVkVGVuYW50cyI6WyJuYXphcmlhIl0sIlRlbmFudE1pZ3JhdGVkIjoiVHJ1ZSIsImp0aSI6IkU4QTAyNzA3NjE3OEU5RUJGREM0MERBOTJFRUYyNjUyIiwic2lkIjoiRkJDODUyMkIzNEE2RUNDQkU0REM0MzdGRTQyOTRBODQiLCJpYXQiOjE3NTI2NzUzNDYsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJlbWFpbCIsIldFQkFQSVBPUlRBTCIsIkNvc21vc1Byb1dlYkFwaSIsIklkZW50aXR5U2VydmVyQXBpIiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbInB3ZCJdfQ.txj9_97q9vFIdiYbBusZEIREu_4nH_ibs5ue3on3J93NaI_hlRFYOch2spG_JaV4dDJcrdax264U_Olt176tTcyMvt3pK1lo_9wSsrDiTY0AOtlfU1JpsnxsfCaukfQmIM2MFsSXFjyjOzwSQXplqJl6V3EwFk9DZsJwGj7I-oQmZctlV0QkB_qV2KuUG0k5izZ7O16N3j68ezFdEYwijcVtEIo-XL7k_h-7ZSzKVATCEyicShvGogRwigfuyR1XD9AWit5SQ_LCHidOGQJi-JuLQdIQ92mf_c8MNXnPNVMSnXx052MTtcfTynpTZSRI7TmoyMkisqBfIvAp7u3vTw'

export const grant_type = 'password';
export const scope = 'offline_access WEBAPIPORTAL CosmosProWebApi profile openid'
export const client_id = 'EPedidos'
export const client_secret = '0edf2f37-70a0-4f38-873d-a9fbf5dfac53'

export function getHeaders(token: string) {
    let newToken = token
    return {
        headers: {
            'Authorization': `Bearer ${newToken}`,
            'api-version': 1,
        }
    }
}

export function notifyChange(message: any, type: any) {
    return Notify({ message: message, height: 45, width: 300, position: { my: "top right", at: "top right", offset: "-10 15" } }, type)
}

export const sendLoadCompleteMessage = () => {
    window.parent.postMessage({ action: "loadComplete" }, "*");
};